import React from 'react';
import { Button } from 'antd';
import Icon from '@ant-design/icons';
import { GlobalVariable } from '@kemu-io/kemu-core/common/managers/globalVariables.js';
import { DataType, SupportedTypes } from '@kemu-io/hs-types';
import { ReactComponent as ReplayIcon } from '@src/assets/img/dataTypes/replay-icon.svg';
import styles from '../GlobalVariablesPanel.module.css';

type Props = {
  variable: GlobalVariable;
  onChange: (name: string, value: SupportedTypes, type: DataType) => void;
  onButtonClick: () => void;
}

/**
 * Button control component for global variables
 * Renders a button that when clicked, triggers an event with boolean value true
 * Uses the same logic as handlePushLocalValue to force value change notification
 * @param variable - The global variable configuration
 * @param onChange - Callback when value changes (not used for button type)
 * @param onButtonClick - Callback when button is clicked (uses push logic)
 */
const ButtonControl = ({ variable, onButtonClick }: Props) => {
  return (
    <Button
      type="text"
      icon={<Icon component={ReplayIcon} />}
      onClick={onButtonClick}
      className={styles.ButtonControl}
    />
  );
};

export default ButtonControl;

